import { useEffect } from 'react';
import useProfile from 'hooks/useProfile';
import { useBranding } from 'hooks/useBranding';

const pushLapTrackerId = 'push-lap-tracker-script';
const pushLapWidgetId = 'push-lap-widget-script';

const withPushLapScript = (Component) => {
  const WrappedComponent = (props) => {
    const { domainConfig } = useBranding();
    
    const { data: userInfo, isLoading } = useProfile();
    useEffect(() => {
      if (!isLoading && userInfo?.adminEmail) {
        // 1 Tracker script
        if (!document.getElementById(pushLapTrackerId)) {
          const trackerScript = document.createElement('script');
          trackerScript.id = pushLapTrackerId;
          trackerScript.src = 'https://pushlapgrowth.com/affiliate-tracker.js';
          trackerScript.setAttribute('data-affiliate', '');
          trackerScript.setAttribute(
            'data-program-id',
            domainConfig.affiliateProgramId
          );
          trackerScript.async = true;
          document.head.appendChild(trackerScript);
        }

        // 2 Widget script
        if (!document.getElementById(pushLapWidgetId)) {
          const widgetScript = document.createElement('script');
          widgetScript.id = pushLapWidgetId;
          widgetScript.src =
            'https://www.pushlapgrowth.com/affiliate-widget.js';
          widgetScript.setAttribute(
            'data-affiliate-program-id',
            domainConfig.affiliateProgramId
          );
          widgetScript.setAttribute('data-user-email', userInfo?.adminEmail || '');
          document.body.appendChild(widgetScript);
        }

        return () => {
          const trackerEl = document.getElementById(pushLapTrackerId);
          if (trackerEl) trackerEl.remove();

          const widgetEl = document.getElementById(pushLapWidgetId);
          if (widgetEl) widgetEl.remove();
        };
      }
    }, [isLoading, userInfo?.adminEmail]);

    return <Component {...props} />;
  };

  return WrappedComponent;
};

export default withPushLapScript;
